import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { qrCode, search } from 'ionicons/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';
import { getSearchEmailEnabled } from '@state/event';
import { Capacitor } from '~capacitor-plugins/core';

import { Scan } from './Scan';
import { Search } from './Search';

const Icon = styled(IonIcon)`
  width: 26px;
  height: 26px;
`;

const Label = styled(IonLabel)`
  font-size: 10px;
`;

enum Tabs {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Scan = 'scan',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Search = 'search',
}

export const PrintBadgeTabs = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const searchEmailEnabled = useSelector(getSearchEmailEnabled);

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path={generateRoute(RoutePath.PrintBadgeScanner)} exact>
          <Scan />
        </Route>
        <Route path={generateRoute(RoutePath.PrintBadgeSearch)} exact>
          <Search />
        </Route>
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        {Capacitor.isNativePlatform() && (
          <IonTabButton
            tab={Tabs.Scan}
            href={generateRoute(RoutePath.PrintBadgeScanner, { eventId })}
          >
            <Icon icon={qrCode} />
            <Label>{t`Scanner`}</Label>
          </IonTabButton>
        )}
        {searchEmailEnabled && (
          <IonTabButton
            tab={Tabs.Search}
            href={generateRoute(RoutePath.PrintBadgeSearch, { eventId })}
          >
            <Icon icon={search} />
            <Label>{t`Search`}</Label>
          </IonTabButton>
        )}
      </IonTabBar>
    </IonTabs>
  );
};
